import React from 'react'
import { graphql } from 'gatsby'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import Button from '../../../atoms/Button'
import CustomTag from '../../../atoms/CustomTag'
import Container from '../../../containers/Container'

import * as style from './style.module.scss'
import 'react-lazy-load-image-component/src/effects/opacity.css'

const AcfImageContent = ({
    altTag,
    buttonLink,
    buttonText,
    content,
    contentPosition,
    heading,
    headingTag,
    imagePercent,
    preview,
    svg,
    titleTag,
}) => {
    const bannerClass = [style.banner]

    if (contentPosition === 'content_right') {
        bannerClass.push(style.bannerRight)
    }

    return (
        <Container>
            <div className={bannerClass.join(' ')}>
                <div className={style.imageWrap}>
                    <div
                        className={style.imageWrap_inner}
                        style={{ paddingBottom: imagePercent }}
                    >
                        {svg && (
                            <LazyLoadImage
                                alt={altTag}
                                className={`lazy ${style.image}`}
                                effect="opacity"
                                src={svg}
                                title={titleTag}
                            />
                        )}
                    </div>
                </div>
                <div className={style.contentWrap}>
                    {heading && (
                        <CustomTag
                            className={style.heading}
                            tag={headingTag || 'h1'}
                        >
                            <span
                                /* eslint-disable react/no-danger */
                                dangerouslySetInnerHTML={{
                                    __html: heading,
                                }}
                            />
                        </CustomTag>
                    )}
                    {content && <p className={style.content}>{content}</p>}
                    {buttonText && buttonLink && (
                        <div className={style.ctaWrap}>
                            <Button to={buttonLink}>{buttonText}</Button>
                        </div>
                    )}
                </div>
            </div>
        </Container>
    )
}

export default AcfImageContent

export const fragment = graphql`
    fragment AcfImageContent on WpPage_Acfflexiblefields_FlexibleFields_ImageContent {
        fieldGroupName
        heading
        headingTag
        content
        contentPosition
        svgImage {
            altText
            title
            mediaDetails {
                height
                width
            }
            localFile {
                publicURL
            }
        }
        button {
            customUrl
            customLink
            text
            link {
                ... on WpPage {
                    slug
                    postType
                }
            }
        }
    }
`
